import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { layerChangeDimension, getWMJSLayerById, WEBMAPJS_REDUCERNAME, webMapJSReducer, layerChangeName } from '@adaguc/react-webmapjs';
import moment from 'moment';
import { selectSPIAction, setSpiMonitorTimeAction, SPI_MONITOR_REDUCERNAME } from './SpiMonitorReducer';
import { getTimeRange } from './TimeDimension';
class FooterContainer extends Component {
  constructor (props) {
    super(props);
    this.toggleDropDownMonth = this.toggleDropDownMonth.bind(this);
    this.toggleDropDownDay = this.toggleDropDownDay.bind(this);
    this.toggleDropDownYear = this.toggleDropDownYear.bind(this);
    this.toggleDropDownSPI = this.toggleDropDownSPI.bind(this);
    this.selectMonth = this.selectMonth.bind(this);
    this.selectDay = this.selectDay.bind(this);
    this.selectYear = this.selectYear.bind(this);
    this.selectSPI = this.selectSPI.bind(this);
    this.updateTime = this.updateTime.bind(this);
    this.state = {
      dropDownMonthIsOpen: false,
      dropDownDayIsOpen: false,
      dropDownYearIsOpen: false,
      dropDownSPIIsOpen: false,
      selectedMonth: '01',
      selectedDay: '01',
      selectedYear: '2000',
      initialTimeSet: false
    };
  }
  componentWillReceiveProps (prevProps) {
    const { dispatch } = this.props;
    if (this.state.initialTimeSet === false) {
      const wmjsLayer = getWMJSLayerById('spiLayerDaily');
      if (!wmjsLayer || !wmjsLayer.getDimension('time')) {
        return;
      }
      const timeDimension = wmjsLayer.getDimension('time');
      // Dimension rebuilt from redux props has no values until GetCapabilities has been parsed.
      if (timeDimension.values === undefined) {
        return;
      }
      const date = moment(timeDimension.currentValue);
      let month = date.format('M');
      let day = date.format('D');
      let year = date.format('YYYY');
      this.setState({
        initialTimeSet:true,
        selectedMonth: ('0' + month).slice(-2),
        selectedDay: ('0' + day).slice(-2),
        selectedYear: year
      }, () => {
        const timeValue = this.state.selectedYear + '-' + this.state.selectedMonth + '-' + this.state.selectedDay + 'T00:00:00Z';
        dispatch(setSpiMonitorTimeAction(timeValue));
      });
    }
  }
  updateTime () {
    const { dispatch } = this.props;
    const timeValue = this.state.selectedYear + '-' + this.state.selectedMonth + '-' + this.state.selectedDay + 'T00:00:00Z';
    dispatch(layerChangeDimension({
      mapPanelId: 'mapid_1',
      layerId:'spiLayerDaily',
      dimension:{
        name: 'time',
        currentValue: timeValue
      }
    }));
    dispatch(setSpiMonitorTimeAction(timeValue));
  }

  selectMonth (month) {
    this.setState({ selectedMonth: month }, () => {
      this.updateTime();
    });
  }

  selectDay (day) {
    this.setState({ selectedDay: day }, () => {
      this.updateTime();
    });
  }

  selectYear (year) {
    this.setState({ selectedYear: year }, () => {
      this.updateTime();
    });
  }

  selectSPI (spi) {
    const { dispatch } = this.props;
    dispatch(selectSPIAction(spi));
    dispatch(layerChangeName({ layerIndex:0, name: 'spi_daily_' + spi, mapPanelId:  'mapid_1' }));
    dispatch(layerChangeName({ layerIndex:1, name: 'spi_percentile_' + spi, mapPanelId:  'mapid_1' }));
  }

  toggleDropDownMonth () {
    this.setState({ dropDownMonthIsOpen: !this.state.dropDownMonthIsOpen });
  }

  toggleDropDownDay () {
    this.setState({ dropDownDayIsOpen: !this.state.dropDownDayIsOpen });
  }

  toggleDropDownYear () {
    this.setState({ dropDownYearIsOpen: !this.state.dropDownYearIsOpen });
  }

  toggleDropDownSPI () {
    this.setState({ dropDownSPIIsOpen: !this.state.dropDownSPIIsOpen });
  }

  render () {
    const { dispatch, spiMonitor } = this.props;

    const wmjsLayer = getWMJSLayerById('spiLayerDaily');
    if (!wmjsLayer) {
      return (<div>Neerslaganomaliegegevens laden...</div>);
    }
    if (!wmjsLayer.getDimension('time')) {
      return (<div style={{
        color:'red',
        fontSize: '30px',
        padding: '6px'
      }}>Kan geen data van de server halen</div>);
    }

    const timeDimension = wmjsLayer.getDimension('time');
    // Dimension rebuilt from redux props has no values until GetCapabilities has been parsed.
    if (timeDimension.values === undefined) {
      return (<div>Neerslaganomaliegegevens laden...</div>);
    }
    const { beginDate, endDate } = getTimeRange(timeDimension.values);
    const { state } = this;
    const myMonths = [
      { name: 'januari', month: '01' },
      { name: 'februari', month: '02' },
      { name: 'maart', month: '03' },
      { name: 'april', month: '04' },
      { name: 'mei', month: '05' },
      { name: 'juni', month: '06' },
      { name: 'juli', month: '07' },
      { name: 'augustus', month: '08' },
      { name: 'september', month: '09' },
      { name: 'oktober', month: '10' },
      { name: 'november', month: '11' },
      { name: 'december', month: '12' }
    ];

    const myDays = [];
    for (var i = 1; i <= moment(this.state.selectedMonth, 'MM').daysInMonth(); i++) {
      myDays.push(('0' + i).slice(-2));
    };

    const myYears = [];
    for (var y = endDate.substring(0, 4); y >= beginDate.substring(0, 4); y--) {
      myYears.push(y);
    };

    // const mySPIs = ['spi1', 'spi3', 'spi6'];
    const mySPIs = [
      { name: 'SPI 1', choice: 'spi1' },
      { name: 'SPI 3', choice: 'spi3' },
      { name: 'SPI 6', choice: 'spi6' }
    ];

    return (
      <Row>
        <Col xs='2' style={{ padding:'0 5px 0 15px' }}>
          <Dropdown style={{ display:'grid', padding:'0 20% 0 5px', width:'150px' }} isOpen={state.dropDownSPIIsOpen} toggle={this.toggleDropDownSPI}>
            <DropdownToggle caret>
              { mySPIs.filter(spi => spi.choice === spiMonitor.selectedSPI)[0].name + ' mnd'}
            </DropdownToggle>
            <DropdownMenu
              modifiers={{
                setMaxHeight: {
                  enabled: true,
                  order: 890,
                  fn: (data) => {
                    return {
                      ...data,
                      styles: {
                        ...data.styles,
                        overflow: 'auto',
                        maxHeight: '50vh'
                      }
                    };
                  }
                }
              }}>
              <DropdownItem header>Selecteer SPI</DropdownItem>
              {
                mySPIs.map((spi, i) => {
                  return (<DropdownItem key={i} active={spi.choice === spiMonitor.selectedSPI} onClick={() => { this.selectSPI(spi.choice); }}>{spi.name + ' mnd'}</DropdownItem>);
                })
              }
            </DropdownMenu>
          </Dropdown>
        </Col>
        <Col xs='2' style={{ padding:'0 5px 0 5px' }}>
          <Dropdown style={{ display:'grid', padding:'0 0 0 30%', marginLeft: 'auto' }} isOpen={state.dropDownMonthIsOpen} toggle={this.toggleDropDownMonth}>
            <DropdownToggle caret>
              { myMonths.filter(month => month.month === this.state.selectedMonth)[0].name }
            </DropdownToggle>
            <DropdownMenu
              modifiers={{
                setMaxHeight: {
                  enabled: true,
                  order: 890,
                  fn: (data) => {
                    return {
                      ...data,
                      styles: {
                        ...data.styles,
                        overflow: 'auto',
                        maxHeight: '50vh'
                      }
                    };
                  }
                }
              }}>
              <DropdownItem header>Selecteer maand</DropdownItem>
              {
                myMonths.map((month, i) => {
                  return (<DropdownItem key={i} active={month.month === this.state.selectedMonth} onClick={() => { this.selectMonth(month.month); }}>{month.name}</DropdownItem>);
                })
              }
            </DropdownMenu>
          </Dropdown>
        </Col>
        <Col xs='1' style={{ padding:'0 5px 0 5px' }}>
          <Dropdown style={{ display:'grid' }} isOpen={state.dropDownDayIsOpen} toggle={this.toggleDropDownDay}>
            <DropdownToggle caret>
              { myDays.filter(day => day === this.state.selectedDay)[0] }
            </DropdownToggle>
            <DropdownMenu
              modifiers={{
                setMaxHeight: {
                  enabled: true,
                  order: 890,
                  fn: (data) => {
                    return {
                      ...data,
                      styles: {
                        ...data.styles,
                        overflow: 'auto',
                        maxHeight: '50vh'
                      }
                    };
                  }
                }
              }}>
              <DropdownItem header>Selecteer dag</DropdownItem>
              {
                myDays.map((day, i) => {
                  return (<DropdownItem key={i} active={day === this.state.selectedDay} onClick={() => { this.selectDay(day); }}>{day}</DropdownItem>);
                })
              }
            </DropdownMenu>
          </Dropdown>
        </Col>
        <Col xs='2' style={{ padding:'0 5px 0 5px' }}>
          <Dropdown style={{ display:'grid', padding:'0 30% 0 0' }} isOpen={state.dropDownYearIsOpen} toggle={this.toggleDropDownYear}>
            <DropdownToggle caret>
              { myYears.filter(year => year === this.state.selectedYear) }
            </DropdownToggle>
            <DropdownMenu
              modifiers={{
                setMaxHeight: {
                  enabled: true,
                  order: 890,
                  fn: (data) => {
                    return {
                      ...data,
                      styles: {
                        ...data.styles,
                        overflow: 'auto',
                        maxHeight: '50vh'
                      }
                    };
                  }
                }
              }}>
              <DropdownItem header>Selecteer jaar</DropdownItem>
              {
                myYears.map((year, i) => {
                  return (<DropdownItem key={i} active={year === this.state.selectedYear} onClick={() => { this.selectYear(year); }}>{year}</DropdownItem>);
                })
              }
            </DropdownMenu>
          </Dropdown>
        </Col>
        <Col xs='3' />
        <Col xs='2' style={{ padding:'0 15px 0 5px' }}>
          <Button className='float-right' onClick={
            () => {
              const wmjsLayer = getWMJSLayerById('spiLayerDaily');
              console.log(wmjsLayer);
              console.log(wmjsLayer.getDimension('time').size());
              dispatch(layerChangeDimension({
                mapPanelId: 'mapid_1',
                layerId:'spiLayerDaily',
                dimension:{
                  name: 'time',
                  currentValue: endDate
                }
              }));
              this.selectDay(('0' + moment(endDate).date()).slice(-2));
              this.selectMonth(('0' + (1 + moment(endDate).month())).slice(-2));
              this.selectYear(moment(endDate).year().toString());
            }
          }>Actueel
          </Button>
        </Col>
      </Row>
    );
  }
};

FooterContainer.propTypes = {
  dispatch: PropTypes.func,
  spiMonitor: PropTypes.object
};

const mapStateToProps = state => {
  /* Return initial state if not yet set */
  const webMapJSState = state[WEBMAPJS_REDUCERNAME] ? state[WEBMAPJS_REDUCERNAME] : webMapJSReducer();
  return {
    mapPanel: webMapJSState.webmapjs.mapPanel,
    spiMonitor: state[SPI_MONITOR_REDUCERNAME]
  };
};

export default connect(mapStateToProps)(FooterContainer);
